import { render } from "./TohPagination.vue?vue&type=template&id=295cd9a9"
import script from "./TohPagination.vue?vue&type=script&lang=js"
export * from "./TohPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__